import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#0F1C38"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FBF223",
      d: "m8.36 12.763-.237 1.284 1.069.75-1.295.173-.384 1.248-.563-1.178-1.306.021.946-.9-.423-1.236 1.148.622zM7.51 7.587l.475 1.217 1.304.076-1.01.827.33 1.264-1.099-.705-1.1.705.332-1.264-1.01-.827 1.303-.076zM10.974 4.456l-.297 1.272 1.032.8-1.302.111-.442 1.23-.507-1.205-1.306-.04.988-.855-.365-1.254 1.118.675zM10.479 16.203l.318 1.266 1.284.24-1.106.694.17 1.295-1.003-.838-1.179.562.487-1.213-.898-.948 1.303.09z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m17.28 14.833-.254-1.624c-.717.558-1.322.733-1.99.733-1.163 0-2.023-.764-2.023-2.357 0-1.528.796-2.34 1.895-2.34.749 0 1.37.223 2.022.716l.271-1.72c-.605-.382-1.37-.652-2.404-.652-2.039 0-3.71 1.369-3.71 4.044 0 2.516 1.512 3.949 3.646 3.949.971 0 1.767-.207 2.548-.749"
    }, null, -1)
  ])))
}
export default { render: render }